<template>
  <div class="d-flex align-center">
    {{ value || '-' }}
    <ul v-if="hasSchedule" class="small-buttons">
      <li>
        <v-menu offset-y :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              v-bind="attrs"
              v-on="on"
              class="transparent-btn ml-2">
              <v-icon>mdi-magnify</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title class="text-subtitle-2">Heti szabályok</v-card-title>
            <v-card-text>
              <v-list>
                <template v-for="(days, index) in schedule">
                  <v-list-item v-for="time in days" :key="index + time.start_time + time.end_time">
                    <v-list-item-title>
                      {{ index }}: {{ time.start_time }}-{{ time.end_time }}
                    </v-list-item-title>
                  </v-list-item>
                </template>
              </v-list>
            </v-card-text>
          </v-card>
        </v-menu>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    schedule: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  computed: {
    hasSchedule() {
      return Object.keys(this.schedule || {}).length > 0;
    },
  },
};
</script>

<style scoped>
li {
  list-style-type: none;
}
ul {
  padding: 0;
}
</style>
